import './AnnotationsAtom.css';
export var wrapper = '_145zb630-3-8-0';